import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import {
  createColorCreator,
  createColorEditor,
} from "../../editors/ColorEditor";
import { colorFormatter } from "../../fomatters/ColorFormatter";

/**
 * TABLE SYSTEMCOLORS
 */
function GameColors() {
  return (
    <Crud
      className="unlock-overflow"
      title="Game Colors"
      getUrl={() => `/Game/SystemColors_GetList`}
      // UPDATE
      updateUrl={() => "/Game/SystemColors_Update"}
      updateParams={(
        { userId },
        { idSystemColors, fkColor, bkColor, description }
      ) => ({
        IdSystemColors: idSystemColors,
        FkColor: fkColor,
        BkColor: bkColor,
        Description: description,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idSystemColors"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataField="description">Name</TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataField="fkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Font
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataField="bkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Background
      </TableHeaderColumn>
    </Crud>
  );
}

export default GameColors;
